var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHollowCutLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0z M36,75.3c-3.5,0-7,0-10.5,0c0-11.2,0-22.4,0-33.6 c0-0.1,0-0.2,0.1-0.2c3.5,0,7,0,10.5,0C36,52.7,36,64,36,75.3z M27.3,35.9c-1.6-1.1-2.9-3.4-2.6-6.1c0.3-2,1.7-3.7,3.2-4.5 c0.5-0.3,1.2-0.5,2-0.5c4-0.5,7,2.3,7,6.1C36.8,35.5,31.5,38.7,27.3,35.9z M75.4,75.3c-3.5,0-7,0-10.5,0c0-3.8,0-7.8,0-12.1 c0-5.1,0.7-11-2.8-12.8c-1.7-0.9-4-0.6-5.5,0c-3.8,1.7-3.5,7.1-3.5,13c0,4.1,0,8.4,0,11.9c-3.5,0-7,0-10.5,0c0-11.3,0-22.6,0-33.8 c3.4,0,6.7,0,10.1,0c0,1.5,0,3.1,0,4.6c0.4-0.3,0.5-0.7,0.8-1.1c1.8-2.4,5-4.4,9.1-4.4c5.2,0,8.9,1.8,10.8,5.1c2,3.5,2,8.4,2,13.9 C75.4,64.7,75.4,70.3,75.4,75.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHollowCutLinkedin);
export default __webpack_public_path__ + "static/media/hollow-cut-linkedin.b89b991b5c36ab0adf6bed275b45433a.svg";
export { ForwardRef as ReactComponent };